import { matchesUA } from 'browserslist-useragent';
import browserslist from '@johnlewispartnership/browserslist-config-wtr/unsupported';

export const isSupportedBrowser = (ua: string | undefined) =>
  ua ? !matchesUA(ua, { browsers: browserslist, allowHigherVersions: false }) : true;

export const isWindowAvailable = typeof window !== 'undefined';
